// eslint-disable-next-line @typescript-eslint/ban-ts-ignore
// @ts-ignore
import tailwindConfig from '@olbbank/theme';

export type Viewport = 'sm' | 'md' | 'lg';

export default class ResponsiveUtils {
	getViewport(): Viewport {
		const matchSm = window.matchMedia(`(max-width: ${tailwindConfig.theme.screens.md})`);
		if (matchSm.matches) return 'sm';

		const matchMd = window.matchMedia(`(max-width: ${tailwindConfig.theme.screens.lg})`);
		if (matchMd.matches) return 'md';

		return 'lg';
	}

	isSm(): boolean {
		const matchSm = window.matchMedia(`(max-width: ${tailwindConfig.theme.screens.md})`);
		return matchSm.matches;
	}

	isMdUp(): boolean {
		const matchMdUp = window.matchMedia(`(min-width: ${tailwindConfig.theme.screens.md})`);
		return matchMdUp.matches;
	}

	isLgDown(): boolean {
		const matchLgDown = window.matchMedia(`(max-width: ${tailwindConfig.theme.screens.lg})`);
		return matchLgDown.matches;
	}

	isMdDown(): boolean {
		const matchMdDown = window.matchMedia(`(max-width: ${tailwindConfig.theme.screens.md})`);
		return matchMdDown.matches;
	}

	isLgUp(): boolean {
		const matchLgUp = window.matchMedia(`(min-width: ${tailwindConfig.theme.screens.lg})`);
		return matchLgUp.matches;
	}
}
